import React, { Fragment } from 'react';
import ProjectDetailRow from '../projectDetailRow';

const ProjectPrioritiesTable = ({ priorities }) => {
    if (priorities && Array.isArray(priorities) && priorities.length > 0) {
        return (
            <table className="default-table table table-sm table-responsive-sm table-hover">
                <tbody>
                    {priorities.map((priority, index) => {
                        return (
                            <ProjectDetailRow key={index} label={priority?.name} description={priority?.value} />
                        );
                    })}
                </tbody>
            </table>
        );
    } else {
        return <Fragment></Fragment>;
    }
};

export default ProjectPrioritiesTable;


// WEBPACK FOOTER //
// ./components/Agile/project/projectDetail/projectPrioritiesTable/index.js